import { Loader2 } from 'lucide-react';

function LoadingOpacitySmallBox() {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50 dark:bg-black dark:bg-opacity-50">
      <div className="flex flex-col items-center justify-center">
        <Loader2 scale={0.5} className="h-7 w-7 animate-spin text-primary/50" />
      </div>
    </div>
  );
}

export default LoadingOpacitySmallBox;
